// State argument is not application state, only the state this reducer is responsible for
function user(state = null, action) {
  switch (action.type) {
    case "SET_USER":
      return action.value;
    default:
      return state;
  }
}
export default user;
